module.exports = __webpack_public_path__ + "assets/img/00093.86694d0e.png";